export const FIELD_TYPES = {
  SINGLE_LIST: 'SINGLE_LIST',
  MULTIPLE_LIST: 'MULTIPLE_LIST',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  TEXTAREA: 'TEXTAREA',
  RADIO: 'RADIO',
  TEXTFIELD: 'TEXTFIELD',
  BUTTON: 'BUTTON',
  UPLOAD: 'UPLOAD',
  BLANK: 'BLANK',
  ICON: 'ICON',
};

export const FIELD = {
  ORDER_TYPE: 'orderIndicatorType',
  BID_OFFER: 'bidOffer',
  FX_RATE: 'fxRate',
  BASKET_FREE_TEXT: 'basketFreeText',
  DURATION: 'duration',
  DIRECTION: 'direction',
  MATURITY_TYPE: 'maturityType',
  CURRENCY: 'currency',
  DEAL_TYPE: 'dealType',
  QUANTITY: 'quantity',
  COLLATERAL_VALUE: 'collateralValue',
  SUBSTITUTABLE: 'substitutable',
  START_CASH: 'startCash',
  EXTENSION_DATE: 'extendableDate',
  FORWARD_START: 'forwardStart',
  SWAP_STRATEGY: 'swapStrategy',
  STRATEGY: 'strategy',
  RESET_TYPE: 'resetType',
  TERM_STRUCTURE: 'termStructure',
  TENORS: 'tenors',
  STEPS: 'steps',
  FLOATINGRATECOMPRESSUI: 'floatingRateCompressedUI',
  CURRENCIES: 'currencies',
  SCHEDULE: 'schedule',
  SPREAD: 'spread',
  BID_SPREAD: 'bidSpread',
  OFFER_SPREAD: 'offerSpread',
  RATE_TYPE: 'rateType',
  REFERENCE_RATE: 'referenceRate',
  CLIENT_RISK_TYPE: 'clientRiskType',
  CLIENT_IDS: 'clientIds',
  COLLATERAL_TYPE: 'collateralType',
  CONTRACT_TYPE: 'clientContractType',
  LEGAL_ENTITY_EXTERNAL_ID: 'legalEntityExternalId',
  COMMENTSTRADE: 'tradeComments',
  UNDERLYING_INSTRUMENT: 'underLyingInstrument',
  STRIKE_PRICE: 'strikePrice',
  SWAP_CURRENCY: 'swapCurrency',
  DIVIDEND_RATE: 'dividendRate',
  BASKET: 'basket',
  SINGLE_SECURITY: 'singleSecurity',
  MARKET_PRICE: 'marketPrice',
  SUBSTITUTION_AND_BR: 'substitutionAndBreakRights',
  COLLATERALBASKETID: 'collateralBasketId',
  ALL_IN_RATE: 'allInRate',
  SETTLEMENT_TYPE: 'settlementType',
  RETURN_TYPE: 'returnType',
  ACTING_AS: 'actingAs',
  CLIENT: 'client',
  FUND: 'fund',
  COUNTERPARTY: 'counterparty',
  PRICETYPE: 'priceType',
  SUBRIGHTS: 'subRights',
  BREAKRIGHTS: 'breakRights',
  RESETFREQUENCY: 'resetFrequency',
  MATURITY: 'maturity',
  SWAPDIRECTION: 'swapDirection',
  SWAPCURRENCY: 'swapCurrency',
  BENCHMARK: 'benchmark',
  FIXINGOFFSET: 'fixingOffset',
  PAYMENTOFFSET: 'paymentOffset',
  SUBPAYMENTS: 'subPayments',
  DIVIDENDPAYMENT: 'dividendPayment',
  FIXEDRATE: 'fixedRate',
  NOTIONAL: 'notional',
  TRADE_DATE: 'tradeDate',
  SETTLEMENT_DATE: 'settlementDate',
  MATURITY_DATE: 'maturityDate',
  TERMINATION_DATE: 'terminationDate',
  COMMENTS: 'orderComments',
  SECURITIES_LIST: 'securitiesList',
  CLIENT_APPROVAL_BTN: 'clientApproval',
  ADD_EDIT_BASKET_ITEMS: 'addEditBasketItems',
  EXECUTE_BTN: 'execute',
  BASKET_UPLOAD: 'basketUpload',
  BASKET_SELECT: 'basketSelect',
  PREVIEW_ICON: 'previewIcon',
  SWAP_NAME: 'swapName',
  TIME_STAMP: 'timeStamp',
  BASKET_NAME: 'basketName',
};

export const SettlementDateByCurrency = [
  { currency: 'GBP', incrementBy: 2 },
  { currency: 'USD', incrementBy: 1 },
  { currency: 'EUR', incrementBy: 2 },
  { currency: 'CAD', incrementBy: 1 },
  { currency: 'JPY', incrementBy: 2 },
  { currency: 'AUD', incrementBy: 2 },
  { currency: 'CHF', incrementBy: 2 },
  { currency: 'SEK', incrementBy: 2 },
  { currency: 'DKK', incrementBy: 2 },
  { currency: 'NOK', incrementBy: 2 },
];

export const LeftFormFields: any = [
  {
    type: 'SINGLE_LIST',
    title: 'Return Type',
    id: FIELD.RETURN_TYPE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Return Type',
    dropdownItems: [
      { id: 'TR', label: 'Total Return' },
      { id: 'PRS', label: 'Price Return Swap' },
    ],
    tableId: 1,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Acting As',
    id: FIELD.ACTING_AS,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Acting As',
    dropdownItems: [
      { id: 'AGNT', label: 'Agent' },
      { id: 'PRCPL-DAY2', label: 'Principal- day2' },
    ],
    tableId: 2,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Client',
    id: FIELD.CLIENT,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Client',
    dropdownItems: [
      { id: 'BO1', label: 'BO1' },
      { id: 'BO2', label: 'BO2' },
      { id: 'BO3', label: 'BO3' },
    ],
    tableId: 3,
    isDisabled: false,
  },
  {
    type: 'TEXTFIELD',
    title: 'Swap Name',
    id: FIELD.SWAP_NAME,
    isMandatory: true,
    placeholder: 'Enter swap name',
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Counterparty',
    id: FIELD.COUNTERPARTY,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Counterparty',
    dropdownItems: [
      { id: 'GS', label: 'Goldman Sachs' },
      { id: 'BOA', label: 'Bank of America' },
      { id: 'BNP', label: 'BNP' },
      { id: 'BRCLS', label: 'Barclays' },
    ],
    tableId: 5,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Price Type',
    id: FIELD.PRICETYPE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Price Type',
    dropdownItems: [
      { id: 'LST', label: 'Last' },
      { id: 'OPN', label: 'Open' },
      { id: 'CLS', label: 'Close' },
    ],
    tableId: 6,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Sub Rights',
    id: FIELD.SUBRIGHTS,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Sub Rights',
    dropdownItems: [
      { id: 'MT-SB', label: 'Mutual Sub' },
      { id: 'NO-SB', label: 'No Sub' },
    ],
    tableId: 7,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Break Rights',
    id: FIELD.BREAKRIGHTS,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Break Rights',
    dropdownItems: [
      { id: 'LST', label: 'Last' },
      { id: 'OPN', label: 'Open' },
      { id: 'CLS', label: 'Close' },
    ],
    tableId: 8,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Reset Frequency',
    id: FIELD.RESETFREQUENCY,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Reset Frequency',
    dropdownItems: [
      { id: 'BLT', label: 'Bullet' },
      { id: 'DLY', label: 'Daily' },
      { id: 'WKLY', label: 'Weekly' },
      { id: 'BI-WKLY', label: 'Bi Weekly' },
      { id: 'MNTY', label: 'Monthly' },
      { id: 'QTR', label: 'Quarterly' },
      { id: 'SX-MNTY', label: 'Six Monthly' },
      { id: 'ANUL', label: 'Annually' },
    ],
    tableId: 9,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Maturity',
    id: FIELD.MATURITY,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Maturity',
    dropdownItems: [
      { id: '1WK', label: '1week' },
      { id: '2WK', label: '2week' },
      { id: '3WK', label: '3week' },
      { id: '1MNT', label: '1Month' },
      { id: '2MNT', label: '2Month' },
      { id: '3MNT', label: '3Month' },
      { id: '6MNT', label: '6Month' },
      { id: '9MNT', label: '9Month' },
      { id: '1YR', label: '1Year' },
    ],
    tableId: 10,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Swap Direction',
    id: FIELD.SWAPDIRECTION,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Swap Direction',
    dropdownItems: [
      { id: 'LNG', label: 'Long' },
      { id: 'SRH', label: 'Short' },
    ],
    tableId: 11,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Swap Currency',
    id: FIELD.SWAPCURRENCY,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Swap Currency',
    dropdownItems: [
      { id: 'GBP', label: 'GBP' },
      { id: 'USD', label: 'USD' },
      { id: 'EUR', label: 'EUR' },
      { id: 'CAD', label: 'CAD' },
      { id: 'JPY', label: 'JPY' },
      { id: 'AUD', label: 'AUD' },
      { id: 'CHF', label: 'CHF' },
      { id: 'SEK', label: 'SEK' },
      { id: 'DKK', label: 'DKK' },
      { id: 'NOK', label: 'NOK' },
    ],
    tableId: 12,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Benchmark',
    id: FIELD.BENCHMARK,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Benchmark',
    dropdownItems: [
      { id: 'FIXED', label: 'FIXED' },
      { id: 'SOFR', label: 'SOFR' },
      { id: 'OBFR', label: 'OBFR' },
      { id: 'ESTRON', label: 'ESTRON' },
      { id: 'SONIA', label: 'SONIA' },
      { id: 'SARON', label: 'SARON' },
      { id: 'NIBOR', label: 'NIBOR' },
      { id: 'NOWA', label: 'NOWA' },
      { id: 'DESTR', label: 'DESTR' },
      { id: 'SWESTR', label: 'SWESTR' },
      { id: 'STIBOR', label: 'STIBOR' },
    ],
    tableId: 13,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Fixing Offset',
    id: FIELD.FIXINGOFFSET,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Fixing Offset',
    dropdownItems: [
      { id: '0D', label: '0d' },
      { id: '1D', label: '1d' },
      { id: '2D', label: '2d' },
    ],
    tableId: 14,
    displayConditionParameters: [FIELD.BENCHMARK],
    displayCondition: (...args) => {
      return args[0] !== 'FIXED';
    },
    isDisabled: false,
  },
  {
    type: 'NUMBER',
    title: 'Rate (%)',
    id: FIELD.FIXEDRATE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Enter Rate (%)',
    className: 'form-control',
    allowNegative: true,
    allowDecimal: true,
    sixDecimal: true,
    isRate: null,
    vacant: false,
    displayConditionParameters: [FIELD.BENCHMARK],
    displayCondition: (...args) => {
      return args[0] === 'FIXED';
    },
    isDisabled: false,
  },
  {
    type: 'NUMBER',
    title: 'Spread (bps)',
    id: FIELD.SPREAD,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Enter Spread (bps)',
    className: 'form-control',
    allowNegative: true,
    allowDecimal: true,
    sixDecimal: true,
    isRate: null,
    vacant: false,
    isDisabled: false,
    allowZero: true,
  },
  {
    type: 'BLANK',
  },
  {
    type: 'SINGLE_LIST',
    title: 'Basket',
    id: FIELD.BASKET_SELECT,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Basket',
    dropdownItems: [
      { id: 'BASKET1', label: 'basket1' },
      { id: 'BASKET2', label: 'basket2' },
      { id: 'BASKET3', label: 'basket3' },
    ],
    displayConditionParameters: [FIELD.SWAPDIRECTION],
    displayCondition: (...args) => {
      return args[0] === 'Long';
    },
    isDisabled: false,
  },
  {
    id: FIELD.PREVIEW_ICON,
    type: 'ICON',
    title: 'Preview',
    displayConditionParameters: [FIELD.SWAPDIRECTION],
    displayCondition: (...args) => {
      return args[0] === 'Long';
    },
    isDisabled: false,
  },
  {
    type: 'RADIO',
    title: 'Underlying Instrument',
    id: FIELD.UNDERLYING_INSTRUMENT,
    isMandatory: false,
    options: [
      {
        name: FIELD.BASKET,
        type: 'radio',
        id: FIELD.BASKET,
        label: 'Basket',
      },
      {
        name: FIELD.SINGLE_SECURITY,
        type: 'radio',
        id: FIELD.SINGLE_SECURITY,
        label: 'Enter Securities',
      },
    ],
    displayConditionParameters: [FIELD.SWAPDIRECTION],
    displayCondition: (...args) => {
      return args[0] === 'Short';
    },
    isDisabled: false,
  },
  {
    type: 'TEXTFIELD',
    title: 'Basket name',
    id: FIELD.BASKET_NAME,
    isMandatory: true,
    placeholder: 'Enter basket name',
    isDisabled: false,
    displayConditionParameters: [FIELD.SWAPDIRECTION, FIELD.UNDERLYING_INSTRUMENT],
    displayCondition: (...args) => {
      return args[0] === 'Short';
    },
  },
  {
    type: 'UPLOAD',
    title: 'Basket Upload',
    id: FIELD.BASKET_UPLOAD,
    displayConditionParameters: [FIELD.SWAPDIRECTION, FIELD.UNDERLYING_INSTRUMENT],
    displayCondition: (...args) => {
      return args[0] === 'Short' && args[1] === 'basket';
    },
    isDisabled: false,
  },
  {
    type: 'BUTTON',
    title: 'Add/Edit Basket Items',
    isMandatory: false,
    id: FIELD.ADD_EDIT_BASKET_ITEMS,
    isDisabled: false,
    displayConditionParameters: [FIELD.SWAPDIRECTION, FIELD.UNDERLYING_INSTRUMENT],
    displayCondition: (...args) => {
      return args[0] === 'Short' && args[1] === 'singleSecurity';
    },
  },
];

export const RightFormFields: any = [
  {
    type: 'NUMBER',
    title: 'Notional',
    id: FIELD.NOTIONAL,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Enter Notional',
    className: 'form-control',
    allowNegative: true,
    allowDecimal: true,
    twoDecimal: true,
    isRate: null,
    vacant: false,
    isDisabled: true,
  },
  {
    type: 'BLANK',
  },
  {
    type: 'DATE',
    title: 'Trade Date',
    id: FIELD.TRADE_DATE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Trade Date',
    className: 'form-control',
    isDisabled: false,
  },
  {
    type: 'DATE',
    title: 'Settlement Date',
    id: FIELD.SETTLEMENT_DATE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Settlement Date',
    className: 'form-control',
    isDisabled: false,
  },
  {
    type: 'DATE',
    title: 'Maturity Date',
    id: FIELD.MATURITY_DATE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Maturity Date',
    className: 'form-control',
    isDisabled: false,
  },
  {
    type: 'DATE',
    title: 'Termination Date',
    id: FIELD.TERMINATION_DATE,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Termination Date',
    className: 'form-control',
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Payment Offset',
    id: FIELD.PAYMENTOFFSET,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Payment Offset',
    dropdownItems: [
      { id: '0D', label: '0d' },
      { id: '1D', label: '1d' },
      { id: '2D', label: '2d' },
    ],
    tableId: 22,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Dividend Payment',
    id: FIELD.DIVIDENDPAYMENT,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Dividend Payment',
    dropdownItems: [
      { id: 'atReset', label: 'At Reset' },
      { id: 'atPayment', label: 'At Payment' },
    ],
    tableId: 23,
    isDisabled: false,
  },
  {
    type: 'SINGLE_LIST',
    title: 'Sub Payments',
    id: FIELD.SUBPAYMENTS,
    isMandatory: true,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Select Sub Payments',
    dropdownItems: [
      { id: 'atReset', label: 'At Reset' },
      { id: 'immediately', label: 'Immediately' },
    ],
    tableId: 24,
    isDisabled: false,
  },
  {
    type: 'TEXTAREA',
    title: 'Comments',
    id: FIELD.COMMENTS,
    isMandatory: false,
    titleClass: '',
    ddClass: 'form-sm',
    noSelectionText: 'Enter Comments',
    className: 'form-control',
    isDisabled: false,
  },
  {
    type: 'BUTTON',
    title: 'Client Approval',
    isMandatory: false,
    id: FIELD.CLIENT_APPROVAL_BTN,
    isFullRow: true,
    isDisabled: false,
  },
  {
    type: 'TEXTFIELD',
    title: 'Time Stamp',
    id: FIELD.TIME_STAMP,
    isMandatory: false,
    placeholder: 'Enter time stamp',
    isDisabled: true,
    validateDateISOString: true,
  },
  {
    type: 'BUTTON',
    title: 'Execute',
    isMandatory: false,
    id: FIELD.EXECUTE_BTN,
    isDisabled: true,
  },
];
